declare namespace $ {

	type $mol_string__hint_bog_vmap_app_scenes_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__enabled_bog_vmap_app_scenes_2 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['current_exists'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__value_bog_vmap_app_scenes_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['doc_title'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_scenes_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_scenes_5 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_vmap_app_scenes_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_list__rows_bog_vmap_app_scenes_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['scene_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_vmap_app_scenes_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['face_brief'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_vmap_app_scenes_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['face_note'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_vmap_app_scenes_10 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['face_who'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_download__title_bog_vmap_app_scenes_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__hint_bog_vmap_app_scenes_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['hint'] >
	>
	type $mol_button_download__blob_bog_vmap_app_scenes_13 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['face_blob'] >
		,
		ReturnType< $mol_button_download['blob'] >
	>
	type $mol_button_download__file_name_bog_vmap_app_scenes_14 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['face_file'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_string__hint_bog_vmap_app_scenes_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_vmap_app_scenes_16 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['face_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_button_minor__title_bog_vmap_app_scenes_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_scenes_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_scenes_19 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['face_take'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_status__status_bog_vmap_app_scenes_20 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['face_status'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_expander__title_bog_vmap_app_scenes_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__expanded_bog_vmap_app_scenes_22 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['face_shown'] >
		,
		ReturnType< $mol_expander['expanded'] >
	>
	type $mol_expander__content_bog_vmap_app_scenes_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $bog_vmap_app_menu__showed_bog_vmap_app_scenes_24 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['menu_showed'] >
		,
		ReturnType< $bog_vmap_app_menu['showed'] >
	>
	type $bog_vmap_app_menu__left_bog_vmap_app_scenes_25 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['menu_left'] >
		,
		ReturnType< $bog_vmap_app_menu['left'] >
	>
	type $bog_vmap_app_menu__top_bog_vmap_app_scenes_26 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['menu_top'] >
		,
		ReturnType< $bog_vmap_app_menu['top'] >
	>
	type $bog_vmap_app_menu__items_bog_vmap_app_scenes_27 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['menu_items'] >
		,
		ReturnType< $bog_vmap_app_menu['items'] >
	>
	type $bog_vmap_app_menu__close_bog_vmap_app_scenes_28 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['menu_close'] >
		,
		ReturnType< $bog_vmap_app_menu['close'] >
	>
	type $bog_vmap_app_palette_item__title_bog_vmap_app_scenes_29 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['scene_title'] >
		,
		ReturnType< $bog_vmap_app_palette_item['title'] >
	>
	type $bog_vmap_app_palette_item__hint_bog_vmap_app_scenes_30 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['scene_title'] >
		,
		ReturnType< $bog_vmap_app_palette_item['hint'] >
	>
	type $bog_vmap_app_palette_item__current_bog_vmap_app_scenes_31 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['scene_current'] >
		,
		ReturnType< $bog_vmap_app_palette_item['current'] >
	>
	type $bog_vmap_app_palette_item__click_bog_vmap_app_scenes_32 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['scene_click'] >
		,
		ReturnType< $bog_vmap_app_palette_item['click'] >
	>
	type $bog_vmap_app_palette_item__event_bog_vmap_app_scenes_33 = $mol_type_enforce<
		({ 
			contextmenu( next?: ReturnType< $bog_vmap_app_scenes['scene_menu'] > ): ReturnType< $bog_vmap_app_scenes['scene_menu'] >,
		})  & ReturnType< $bog_vmap_app_palette_item['event'] >
		,
		ReturnType< $bog_vmap_app_palette_item['event'] >
	>
	type $bog_vmap_app_menu_item__title_bog_vmap_app_scenes_34 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_menu_item['title'] >
	>
	type $bog_vmap_app_menu_item__act_bog_vmap_app_scenes_35 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['drop_ask'] >
		,
		ReturnType< $bog_vmap_app_menu_item['act'] >
	>
	type $mol_paragraph__title_bog_vmap_app_scenes_36 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['drop_note'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $bog_vmap_app_menu_item__title_bog_vmap_app_scenes_37 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_menu_item['title'] >
	>
	type $bog_vmap_app_menu_item__act_bog_vmap_app_scenes_38 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['drop'] >
		,
		ReturnType< $bog_vmap_app_menu_item['act'] >
	>
	type $bog_vmap_app_menu_item__done_bog_vmap_app_scenes_39 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['menu_close'] >
		,
		ReturnType< $bog_vmap_app_menu_item['done'] >
	>
	type $bog_vmap_app_menu_item__title_bog_vmap_app_scenes_40 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_menu_item['title'] >
	>
	type $bog_vmap_app_menu_item__act_bog_vmap_app_scenes_41 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_scenes['menu_close'] >
		,
		ReturnType< $bog_vmap_app_menu_item['act'] >
	>
	export class $bog_vmap_app_scenes extends $mol_page {
		Name( ): $mol_string
		add( next?: any ): any
		Add_icon( ): $mol_icon_plus
		Add( ): $mol_button_minor
		scene_rows( ): readonly(any)[]
		List( ): $mol_list
		face_brief( ): string
		Face_brief( ): $mol_paragraph
		face_shown( next?: boolean ): boolean
		Face_note( ): $mol_paragraph
		Face_who( ): $mol_paragraph
		face_blob( ): $mol_blob
		Face_save( ): $mol_button_download
		Face_field( ): $mol_string
		Face_take( ): $mol_button_minor
		Face_status( ): $mol_status
		Face( ): $mol_expander
		menu_showed( next?: boolean ): boolean
		menu_left( ): string
		menu_top( ): string
		menu_items( ): readonly($mol_view)[]
		menu_close( next?: any ): any
		scene_title( id: any): string
		scene_current( id: any): boolean
		scene_click( id: any, next?: any ): any
		scene_menu( id: any, next?: any ): any
		drop_ask( next?: any ): any
		drop_note( ): string
		drop( next?: any ): any
		store( ): $bog_vmap_app_store
		current( next?: string ): string
		doc_title( next?: string ): string
		current_exists( ): boolean
		title( ): string
		tools( ): readonly(any)[]
		face_note( ): string
		face_who( ): string
		face_file( ): string
		face_draft( next?: string ): string
		face_take( next?: any ): any
		face_status( ): string
		body( ): readonly(any)[]
		foot( ): readonly(any)[]
		Menu( ): $bog_vmap_app_menu
		Scene_row( id: any): $bog_vmap_app_palette_item
		Drop( ): $bog_vmap_app_menu_item
		Drop_note( ): $mol_paragraph
		Drop_yes( ): $bog_vmap_app_menu_item
		Drop_no( ): $bog_vmap_app_menu_item
	}
	
}

//# sourceMappingURL=scenes.view.tree.d.ts.map